import { DoseMatrix } from '~/domain/patient/doseMatrix';
import { DoseViewData } from '~/state/atoms/dose/doseAtoms';

/**
 * Pure transform: derives a {@link DoseViewData} snapshot from a {@link DoseMatrix}.
 *
 * DVH curve data is no longer included here — it is managed separately
 * via {@link dicomDvhCurvesState} and {@link DoseMatrix.buildDicomDvhCurves}
 * to decouple dose visualization re-renders from DVH chart re-renders.
 */
export default function transformDoseMatrixToDoseData(
    doseMatrix: DoseMatrix
): DoseViewData {
    const doseScale = doseMatrix.doseScale;
    const manufacturer = doseMatrix.dicomDose.manufacturer;
    const generated = manufacturer === 'MVision AI';

    return {
        id: doseMatrix.dicomUid,
        sopUid: doseMatrix.dicomUid,
        normalizationValueGy: doseMatrix.normalizationValueGy,
        doseScale: doseMatrix.doseScale,
        type: doseMatrix.doseType,
        summationType: doseMatrix.doseSummationType,
        doseGridResolution: doseMatrix.grid.getRes(),
        planLabel: doseMatrix.plan?.label,
        maxDoseGy: doseMatrix.doseMaxGy * doseScale,
        generated,
        manufacturer,
        manufacturerModelName: doseMatrix.dicomDose.manufacturerModelName,
        seriesDescription: doseMatrix.dicomDose.seriesDescription,
        doseComment: doseMatrix.dicomDose.doseComment,
        softwareVersions: doseMatrix.dicomDose.softwareVersions,
        targets: doseMatrix.targets,
    };
}
